<template>
    <div class="product_container">
        <!-- swiper 轮播 -->
        <el-carousel :interval="5000" height="531px">
            <el-carousel-item v-for="item in bannerList" :key="item.id">
                <div @click="toTarget(item.targetUrl)" class="swiper_item"
                    :style="{ backgroundImage: `url(${item?.iconUrl})` }">
                    <!-- <div style="height: 100%; background-color: rgba(0, 0, 0, .5);">
                        {{ item }}
                    </div> -->
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="product">
            <div class="product_item" @click="router.push({ path: '/home/productDetail', query: { id: item.id } })"
                v-for="item in productList">
                <div class="bgc" :style="{ backgroundImage: `url(${item.mainPic})`, }">
                    <div class="product_title des_one_row">{{ item.productName }}</div>
                    <div class="product_des des_one_row">{{ item.sellingPoint }}</div>
                    <div class="product_more">了解更多<el-icon style="width: 20px;transform: translateY(2px);" class="iconcolor"
                            color="#386AEA">
                            <ArrowRight />
                        </el-icon></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount , onUnmounted } from 'vue'
import { getProductList, getBannerList } from '@/api/shop'
import { debounce } from '@/utils/common'
import { useRouter } from 'vue-router'
const router = useRouter()
const bannerList = ref([])
const productList = ref([])
const limit = ref(1)
onBeforeMount(() => {
    getProduct()
})
//获取产品 轮播图
const getProduct = () => {
    // TODO 1.2接口
    // getProductList({ limit: limit.value, offset: 20 }).then(res => {
    //     productList.value = [...productList.value, ...res.result.data]
    //     console.log(productList.value);
    // }).catch(err => { console.log(err); })
    getBannerList().then(res => {
        // console.log(res);
        bannerList.value = res.result
    }).catch(err => { console.log(err); })
}
onMounted(() => {
    window.addEventListener('scroll', handleScroll)
})
onUnmounted(()=>{
    window.removeEventListener('scroll', handleScroll);
})
const handleScroll = debounce((e) => {
    let  el = document.scrollingElement
    // console.log(e,el.scrollTop+el.clientHeight,el.scrollHeight);
    if (el.scrollHeight - (el.scrollTop + el.clientHeight) < 10) {
        limit.value = limit.value + 1
        getProduct()
    }
},500)
    //跳转其他页
    const toTarget = (url) => {
        if (!url) return
        window.open(url)
    }
</script>

<style lang="scss" scoped>
div {
    color: #fff;
}

.des_one_row {
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -webkit-ellipsis-lastline;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

.product_container {
    min-height: 100vh;
    background-color: #111;

    .product {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 19px;

        .product_item {
            width: calc(50% - 8px);
            margin-bottom: 16px;
            cursor: pointer;
            background-color: #1f1f1f;

            .bgc {
                width: 100%;
                height: 100%;
                background-size: cover;
                background-position: center;
            }

            .product_title {
                color: #FFF;
                // font-family: PingFang SC;
                font-size: 32px;
                font-weight: 500;
                text-align: center;
                padding-top: 60px;
            }

            .product_des {
                color: #FFF;
                // font-family: PingFang SC;
                font-size: 20px;
                font-weight: 500;
                text-align: center;
                margin-top: 8px;
            }

            .product_more {
                color: #386AEA;
                // font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 200%;
                text-align: center;
                margin-top: 18px;
            }
        }

        .product_item:not(:nth-child(2n)) {
            margin-right: 16px;
        }

        .product_item:last-child {
            margin-bottom: 24px;
        }
    }
}



@media (min-width: 1200px) {
    .product_item {
        width: 50%;
        height: 535px;
    }
}

@media (max-width: 1200px) {
    .product_item {
        width: 50%;
        height: 435px;
    }
}




.swiper_item {
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

::v-deep .is-active .el-carousel__button {
    background-color: #16D97B;
}

::v-deep .el-carousel__button {
    background-color: #16D97B;
}</style>